import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private routeEditable: boolean;
  private permissions=new BehaviorSubject<any>([]);
  private userPermissions:any;
  private routeName: string;
  private isSuperAdmin:boolean;

  constructor() { }

  public getPermissions(): Observable<String> {
    return this.permissions.asObservable();
  }

  setPermissions = (permissions: any) => {
    this.userPermissions=permissions;
    return this.permissions.next(permissions);
  }
  setEditable = (val) => {
    this.routeEditable = val;
  }

  isEditable = () => {
    return this.routeEditable
  }

  setRouteName = (routeName: string) => {
    this.routeName = routeName;
  }

  getRouteName = () => {
    return this.routeName
  }

  getUserPermissions(){
    return this.userPermissions;
  }

  setIsSuperAdmin(isSuperAdmin: boolean) {
    this.isSuperAdmin = isSuperAdmin;
  }
  getIsSuperAdmin() {
    return this.isSuperAdmin;
  }
}
